/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { FormHelperText, Typography, Grid } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const SelectBox = (props) => {
  const {
    name,
    value,
    label,
    required,
    placeholder,
    options,
    variant = 'outlined',
    size = 'small',
    error = null,
    onChange,
    labelClass,
    maxMenuHeight,
    dataModuleId,
    fontSize,
    ...others
  } = props;

  const [state, setState] = React.useState('');

  useEffect(() => {
    setState(value);
  }, [value]);

  const handleChange = (event) => {
    setState(event?.target?.value);
    onChange(event);
  };

  return (
    <FormControl
      variant={variant}
      size={size}
      className="formControl inlineselect"
      {...(error && { error: true, helpertext: error })}
    >
      <Grid container spacing={0}>
        {label && (
          <Grid item xs={12} md={4} className='inlineLabel'>
            <Typography
              component="p"
              className={`${required ? 'inputLabel required' : 'inputLabel'} label ${labelClass}`}
              sx={{ fontSize: fontSize ? `${fontSize} !important` : undefined }}
            >
              {label}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} md={label ? 8 : 12}>
          <Select
            name={name}
            value={state}
            onChange={handleChange}
            displayEmpty
            fullWidth
            inputProps={{ 'aria-label': 'Without label' }}
            size={size}
            {...others}
            className="selectInput"
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              PaperProps: {
                style: {
                  maxHeight: maxMenuHeight ? maxMenuHeight : 'auto',
                },
              }
            }}
            sx={{
              '& .MuiSelect-icon': {
                color: '#B72755 !important',
                fontSize: '1.2857142857142856rem !important',
              },
            }}
          >
          {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
          {options &&
            options?.map((item) => (
              <MenuItem key={item?.value} value={item?.value} id={dataModuleId ? `${dataModuleId}-${item?.value?.replace("_", "-")}` : undefined}>
                {item?.title}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{error && error}</FormHelperText>
      </Grid>
    </Grid>
    </FormControl >
  );
};

export default SelectBox;
